// Illustrated concern icons (translucent vector style with herbal leaves).
const B = "https://static.prod-images.emergentagent.com/jobs/39cba0d0-46f2-4071-8817-dc7f428056b8/images/";
const IMG = {
  sinusitis: B + "d2432b55ac9d41b2377e9446268de57618fe6faee9a8a7b989ab156b4b39ae80.jpeg",
  smoking: B + "a70a29c2f1a6e058115d4cb0f20292a21a07abc6d1188ed5dad8dd41a36c3fe3.jpeg",
  stomach_ulcer: B + "1e7f77aad3e278143dce3ca5dc505c1a40983501d65bd33aa041cd92fd2bd866.jpeg",
  tonsils: B + "f5e9d5ed5be1499743b9acb824b73199622c34481fe05f8511f2d842c0135d92.jpeg",
  tuberculosis: B + "988d1aee5996f355de374f0f58857dab8a06291de9ef9514c4ce2fa19baab262.jpeg",
  immunity: B + "ba110da7e459110a4ed98c1757bff07dd8e4913d1e2c54988b2efb071f3cee98.jpeg",
  diabetes: B + "7d433be3ac7c0c956530f29e17994601d3d4251585d37cc884b96aedca73979f.jpeg",
  hair: B + "b425c13adcca460b0efd4146473664f30cd57c1d6de43fa16de41df283ba6534.jpeg",
  skin: B + "0ed064ca4c06e3b1dcf64776fa8ab10913d32243b95ace1c007d8af3bc12bc85.jpeg",
  heart: B + "4d43a6e018908ed89369b22a3d63a8a3c13856a37c1cd8f6f5f25844deff7eb2.jpeg",
  joint_pain: B + "5cdc1ed5efa46125dacb0c8fe82adb82d8621466d63418eba33763994be368de.jpeg",
  digestion: B + "1c380deb4f4b1326d71c511f0ceaa99c86c65c735785a56889b3ecbb738296b0.jpeg",
  liver: B + "a0463942f6f48fae6c4eda3e5c47b4cedbd83f2a6fba2abece60f265802d7845.jpeg",
  kidney: B + "3b14cdc8ab1dd949e797ba2d7c43e276266cd90b0f324d58821e9f73b9d382da.jpeg",
  respiratory: B + "b3fdd4bdd8160a35b6e5f31bdce3a330d6ae5dd65b25a94ee72bbd509e635f88.jpeg",
  weight: B + "c13f312748bbbb12fa0bb1b4345322bb194d6f10d992f7e2f3d621c988f83602.jpeg",
  stress_sleep: B + "05e57ae17eddfe81d3377df28b5bd369adc517cd89c229dfab5a8296c4715e74.jpeg",
  eye: B + "197e520e4ee5f6ea13e4fdb8b66190c3494a97d804cd5a069f846c3d44691b90.jpeg",
  womens_health: B + "95f9b7971cc611d6dadd7451f2c5be3e199d3d136fe71f3da61839a5f0fbd876.jpeg",
  thyroid: B + "9fd7c1fd4af30588a73c38af0d054aa9e0e331db52d65859cdeae2869dd0eef0.jpeg",
};

const MAP = [
  { kw: ["sinus"], img: IMG.sinusitis },
  { kw: ["smok", "tobacco", "cigarette"], img: IMG.smoking },
  { kw: ["ulcer", "gastr", "acid"], img: IMG.stomach_ulcer },
  { kw: ["tonsil"], img: IMG.tonsils },
  { kw: ["tuberculosis", "tb "], img: IMG.tuberculosis },
  { kw: ["immun", "cold", "cough", "flu", "fever", "vitality"], img: IMG.immunity },
  { kw: ["diabet", "sugar", "glucose"], img: IMG.diabetes },
  { kw: ["hair", "scalp", "dandruff"], img: IMG.hair },
  { kw: ["skin", "acne", "glow", "pigment"], img: IMG.skin },
  { kw: ["heart", "cardio", "bp", "blood pressure", "cholesterol"], img: IMG.heart },
  { kw: ["joint", "bone", "arthrit", "knee", "back pain", "muscle"], img: IMG.joint_pain },
  { kw: ["digest", "stomach", "constipat", "piles", "gut"], img: IMG.digestion },
  { kw: ["liver", "detox", "hepat"], img: IMG.liver },
  { kw: ["kidney", "urine", "urinary", "renal"], img: IMG.kidney },
  { kw: ["asthma", "respirat", "lung", "breath", "bronch"], img: IMG.respiratory },
  { kw: ["weight", "obes", "fat", "slim"], img: IMG.weight },
  { kw: ["stress", "sleep", "insomnia", "anxiety", "mental", "depress"], img: IMG.stress_sleep },
  { kw: ["eye", "vision", "sight"], img: IMG.eye },
  { kw: ["women", "pregnan", "fertil", "period", "menstru", "pcod", "pcos"], img: IMG.womens_health },
  { kw: ["thyroid"], img: IMG.thyroid },
];

// Returns an illustrated image URL for a concern name, or null if no match.
export function concernImage(name = "") {
  const n = String(name).toLowerCase();
  for (const m of MAP) if (m.kw.some((k) => n.includes(k.trim()))) return m.img;
  return null;
}
